module.exports = __webpack_public_path__ + "static/img/eTower_reverse_white.a5cae40c.png";